module.exports = __webpack_public_path__ + "static/img/1a (7).c0f4d7ad.png";